"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAozProductIdFromVehicle = exports.addAozProductIdForVehicle = exports.REMOVE_AOZ_PRODUCT_ID_FROM_VEHICLE = exports.ADD_AOZ_PRODUCT_ID_FOR_VEHICLE = exports.AOZ = void 0;
exports.AOZ = 'details aoz';
exports.ADD_AOZ_PRODUCT_ID_FOR_VEHICLE = `${exports.AOZ} ADD`;
exports.REMOVE_AOZ_PRODUCT_ID_FROM_VEHICLE = `${exports.AOZ} REMOVE`;
const addAozProductIdForVehicle = (state = {}) => ({
    type: exports.ADD_AOZ_PRODUCT_ID_FOR_VEHICLE,
    payload: state,
    meta: { feature: exports.AOZ },
});
exports.addAozProductIdForVehicle = addAozProductIdForVehicle;
const removeAozProductIdFromVehicle = (state = {}) => ({
    type: exports.REMOVE_AOZ_PRODUCT_ID_FROM_VEHICLE,
    payload: state,
    meta: { feature: exports.AOZ },
});
exports.removeAozProductIdFromVehicle = removeAozProductIdFromVehicle;
//# sourceMappingURL=aozAction.js.map